import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { GetServiceLayerIdsFragmentFragmentDoc } from '@packages/gql/generated/shopping/GetServiceLayerIdsFragmentFragmentDoc';

/* GraphQL */ `
  fragment GetServiceLayerIdsFragment on Product {
    productHints {
      serviceLayerId
    }
    ecoLabels {
      serviceLayerId
    }
    legalHints {
      serviceLayerId
    }
  }
`;

export type GetServiceLayerIdsProps = FragmentType<typeof GetServiceLayerIdsFragmentFragmentDoc>;

export const getServiceLayerIds = (data: GetServiceLayerIdsProps) => {
  const { ecoLabels, legalHints, productHints } = getFragmentData(
    GetServiceLayerIdsFragmentFragmentDoc,
    data,
  );

  const serviceLayerIds: string[] = [];

  [productHints, ecoLabels, legalHints].forEach((serviceLayerContainer) => {
    serviceLayerContainer.forEach((item) => {
      if (item.serviceLayerId) {
        serviceLayerIds.push(item.serviceLayerId);
      }
    });
  });

  return serviceLayerIds;
};
